import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { countries } from "../../../../../_common/utils/phone/data";
import { obterChaveDicCountry } from "../../../../../_common/utils/phone";

function FlagDDI({ ddi, className, telefone }) {
  let chaceDicCountry;
  if (!telefone) {
    chaceDicCountry = (ddi + telefone).substring(0, 4);
  } else {
    chaceDicCountry = obterChaveDicCountry(ddi, telefone);
  }

  const country = useMemo(() => countries[chaceDicCountry] ?? null, [chaceDicCountry]);

  return country ? <img className={className} src={country.flag} alt={country.name} /> : null;
}

FlagDDI.propTypes = {
  ddi: PropTypes.string,
  className: PropTypes.string,
  telefone: PropTypes.string,
};

export default FlagDDI;
